/**
 * Configuración visual de cada estatus de cotización (label, icono, color, severity del Tag).
 * Extraído de DetallesComponent para que no viva escondido dentro de un componente de render.
 */
export const ESTATUS_CONFIG = {
    1: { label: "Nuevo",                 icon: "pi pi-file",         color: "#2196F3", severity: "info" },
    2: { label: "En Planeación",         icon: "pi pi-pencil",       color: "#FF9800", severity: "warning" },
    3: { label: "En Costeo",             icon: "pi pi-calculator",   color: "#9C27B0", severity: "secondary" },
    4: { label: "Esperando Aprobación",  icon: "pi pi-clock",        color: "#FF5722", severity: "danger" },
    5: { label: "Aprobado",              icon: "pi pi-check-circle", color: "#4CAF50", severity: "success" },
    6: { label: "En Producción",         icon: "pi pi-cog",          color: "#00BCD4", severity: "success" },
    8: { label: "Solicitud de Cambios",  icon: "pi pi-file",         color: "#FF5722", severity: "danger" },
    9: { label: "Costeado",              icon: "pi pi-receipt",      color: "#2196F3", severity: "warning" },
};

export const DIAS_SEMANA = [
    { campo: "lunes",     label: "Lun" },
    { campo: "martes",    label: "Mar" },
    { campo: "miercoles", label: "Mié" },
    { campo: "jueves",    label: "Jue" },
    { campo: "viernes",   label: "Vie" },
    { campo: "sabado",    label: "Sáb" },
    { campo: "domingo",   label: "Dom" },
];
